import en from '../../locales/en.json';
import fr from '../../locales/fr.json';
import ar from '../../locales/ar.json';
import es from '../../locales/es.json';
import tr from '../../locales/tr.json';
import de from '../../locales/de.json';
import id from '../../locales/id.json';
import ms from '../../locales/ms.json';
import th from '../../locales/th.json';
import el from '../../locales/el.json';
import fi from '../../locales/fi.json';
import hr from '../../locales/hr.json';
import ru from '../../locales/ru.json';
import nl from '../../locales/nl.json';
import zh from '../../locales/zh.json';
import sv from '../../locales/sv.json';
import no from '../../locales/no.json';
import hu from '../../locales/hu.json';
import da from '../../locales/da.json';
import pl from '../../locales/pl.json';
import cs from '../../locales/cs.json';
import is from '../../locales/is.json';
import it from '../../locales/it.json';
import { isSpecialBrandsForLocale } from '../../controls/common/constants/specialCases';

const translations:ITranslations = { en, fr, ar, es, tr, de, id, ms, th, el, fi, hr, ru, nl, zh, sv, no, hu, da, pl, cs, is, it };

interface ITranslations {
  [languageCode: string]: {
    [key1: string]: {
      [key2: string]: string;
    };
  };
}

export function getLocaleFromUrl(brandID: string) {
  if(typeof window !== 'undefined' && window.parent.location.href.includes("locale")){
      const url = window.parent.location.href;
      let localeMatch = url.match(/[?&]locale=([a-zA-Z\-]+)/);
      if (localeMatch && localeMatch[1]) {
          return localeMatch[1];
      }
  }else if(isSpecialBrandsForLocale(brandID) && typeof window !== 'undefined'){
    const url = window.parent.location.href;
    let localeMatch = url.match(/\/\/[^\/]+\/([a-zA-Z]{2})(?:[\/\?#]|$)/);
    if (localeMatch && localeMatch[1]) {
        const lc = localeMatch[1].toLowerCase();
        if (lc.length === 2 && Object.prototype.hasOwnProperty.call(translations, lc)) {
            return lc;
        }
    }
  }
  return 'en';
}

export const useTranslation = () => {
  const t = (key1: any, key2: any, locale: string) => {
    return translations[locale]?.[key1]?.[key2] || translations["en"]?.[key1]?.[key2] || key2;
  };
  return { t };
};